// Quick Firebase Connection Test
import { clientService, productService, orderService } from '../services/firebaseService';

export const testFirebaseConnection = async () => {
  console.log('🔥 Testing Firebase Connection...');
  
  try {
    // Test 1: Try to get all products
    console.log('📦 Testing products collection...');
    const products = await productService.getAllProducts();
    console.log(`✅ Products found: ${products.length}`);
    
    // Test 2: Try to get all clients
    console.log('👥 Testing clients collection...');
    const clients = await clientService.getAllClients();
    console.log(`✅ Clients found: ${clients.length}`);
    
    // Test 3: Try to get all orders
    console.log('📋 Testing orders collection...');
    const orders = await orderService.getAllOrders();
    console.log(`✅ Orders found: ${orders.length}`);
    
    console.log('🎉 Firebase connection test completed successfully!');
    return { success: true, products, clients, orders };
    
  } catch (error) {
    console.error('❌ Firebase connection test failed:', error);
    return { success: false, error: error.message };
  }
};

// Test creating a simple client
export const testCreateClient = async () => {
  console.log('🧪 Testing client creation...');
  
  try {
    const testClient = {
      firstName: 'Test',
      lastName: 'User',
      email: 'test@example.com',
      phone: '+27123456789',
      address: {
        street: '123 Test Street',
        city: 'Test City',
        postalCode: '1234'
      }
    };
    
    const result = await clientService.createClient(testClient);
    console.log('✅ Test client created:', result.id);
    return { success: true, clientId: result.id };
    
  } catch (error) {
    console.error('❌ Client creation failed:', error);
    return { success: false, error: error.message };
  }
};